import { Reveal, SectionHeading } from "./Reveal";

const steps = [
  {
    n: "01",
    title: "Nos ponemos en contacto",
    desc: "Escríbeme por WhatsApp, correo o mediante el formulario. Te respondo personalmente y sin compromiso.",
  },
  {
    n: "02",
    title: "Escucho y comprendo la situación",
    desc: "Una primera conversación tranquila para conocer a la familia y entender qué está ocurriendo.",
  },
  {
    n: "03",
    title: "Valoro las necesidades y defino objetivos",
    desc: "Analizo el caso con mirada profesional y acordamos metas claras y realistas.",
  },
  {
    n: "04",
    title: "Plan individualizado y revisión de avances",
    desc: "Diseño un plan de intervención a medida y reviso los progresos junto a la familia.",
  },
];

export default function Process() {
  return (
    <section
      id="como-trabajamos"
      data-testid="process-section"
      className="py-20 lg:py-28 bg-atento-deep relative overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute top-0 right-0 w-[420px] h-[420px] rounded-full bg-sage/10 blur-3xl"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          dark
          eyebrow="¿Cómo trabajamos?"
          title="Un proceso claro, paso a paso"
          intro="Sé que dar el primer paso puede generar dudas. Por eso trabajo con un camino sencillo y transparente, pensado para dar tranquilidad a las familias."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div data-testid={`process-step-${i}`} className="relative group">
                <div className="flex items-center gap-4">
                  <span className="font-serif italic text-5xl sm:text-6xl text-sage/80 group-hover:text-sage transition-colors duration-300">
                    {s.n}
                  </span>
                  <span className="hidden lg:block flex-1 h-px bg-ivory/15" aria-hidden="true" />
                </div>
                <h3 className="mt-5 font-accent font-semibold text-lg text-ivory leading-snug">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ivory/65">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
